<template>
  <div class="shops-module">
      <div class="shop-list-container d-flex flex-column">
        <div class="topbar"></div>
        <h3 class="text-center">{{this.$route.params.name}}</h3>

        <div class="main-inner-list d-flex flex-column">
          <p class="text-center units-title">واحد ها</p>

          <div class="shop-item-list d-flex flex-row row justify-content-around p-3" v-if="items != null">

            <router-link tag="div" v-for="item in items" class="shop-item d-flex flex-column col-4 mb-4" :to="`/asnaf/shop/${item.id}`">
              <div class="shop-image">
                <img :src="`https://kishoto.ir/dtr/approid/img/${item.image}`" @error="defaultImage">
              </div>
              <p>{{item.name}}</p>
            </router-link>

          </div>

          <div class="shop-item-list d-flex flex-row row justify-content-around p-3" v-else>
                <div class="not-found-item">محتوایی یافت نشد</div>
          </div>

          </div>
      </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      items:[]
    };
  },
  created() {
    this.getAsnafs();
  },
  methods: {
    async getAsnafs() {
      let fd = new FormData();
      fd.append("flag","mall");
      fd.append("mid",this.$route.params.id);

      const response = await this.$ApiServiceLayer.post("get_shops",fd);
      console.log(response);
      if (response.status_code === 200) {
        this.items = response.list;
      }

      if (response.status_code === 404) {
        this.items = null;
      }
    },
    defaultImage(e){
      console.log("test");
      e.target.onerror=null;
      e.target.src = 'https://kishoto.ir/dtr/approid/img/logo1.png';
    }
  },
};
</script>

<style lang="scss" scoped>
.shops-module {
  width: 100%;
  min-height: 100vh;
  background: #ffffff;
  .topbar{
    background: #f44336;
    height: 15px;
    width: 100%;
    margin-bottom: 36px;
  }
  h3{
    color: #455a64;
    font-weight: bold;
    margin-bottom: 12px;
  }
  .shop-list-container{
    .main-inner-list{
      .units-title{
        color: #455a64;
        font-size: 22px;
        margin-top: 36px;
      }
      .shop-item-list{
        .shop-item{
          box-shadow:0px 1px 9px #808080a3;
          border-radius: 12px;
          padding: 12px 7px 9px 7px;
          width: 31%;
          .shop-image{
            display: flex;
            justify-content: center;
            img{
              width: 100%;
              height: 110px;
              border-radius: 9px;
            }
          }
          p{
            text-align: center;
            margin-bottom: 0;
            margin-top: 10px;
          }
        }

        .not-found-item{
          text-align: center;
          justify-content: center;
          display: flex;
          padding: 5px;
          background: #f44336d6;
          color: #ffff;
          width: 61%;
          border-radius: 5px;
        }
      }
    }
  }
}
</style>
